module.exports = __webpack_public_path__ + "static/media/knob.9f2111d5.png";